var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:{
    button: true,
    'button--small': _vm.size === 'small',
    'button--white': _vm.type === 'white',
  }},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }